export default __webpack_public_path__ + "static/media/Room1.ff4fd8d5.png";